/*
 * @Author: bianbinbin
 * @Date: 2023-11-27 13:45:03
 * @LastEditors: bianbinbin
 * @LastEditTime: 2023-12-18 16:31:43
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/store/index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
// import discount from './module/discount'
// import organization from './module/organization'
// vuex数据持久化插件
import { createVuexPersistedState } from 'vue-persistedstate'
const files = require.context('./module', false, /\.js$/)
const modules = {}

files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    id: 1
  },
  getters: {
    getId: state => state.id,
    userInfoObj: state => state.user.userInfoObj,
    seatId: state => state.user.seatId,
    isDutyDone: state => state.user.isDutyDone,
    code: state => state.user.code,
    yearReportObj: state => state.user.yearReportObj,
    menuList: state => state.user.menuList
  },
  mutations: {
    setId: (state, data) => (state.id = data)
  },
  actions: {},
  modules,
  // modules: {
  //   discount,
  //   organization
  // },
  plugins: [
    createVuexPersistedState({
      // storage: window.localStorage,
      // whiteList: [],
      // blackList: []
      paths: [modules.discount]
    })
  ]
})
